import {HydraListResponse, HydraModel} from '@mgp-fe/shared/core-api/domain/base.ts';

export function getCollectionSearchParams(page: CollectionPage, collectionResponse?: HydraListResponse<HydraModel>): URLSearchParams {
	if(!collectionResponse) return new URLSearchParams();

	return new URL(collectionResponse?.['hydra:view'][`hydra:${page}`] || '', 'http://localhost').searchParams;
}

export type CollectionPage = 'first' | 'previous' | 'next' | 'last';